import {AdSize} from "@rezonence/prebid-api";

export const mpuSize: AdSize = [300, 250];
